import { HttpHelperService, ApiHelperServiceNew, ExcelService } from 'app/core/services';
import { FilterOption, TableFilter, ITableFilterDefault, SortByDirection, SortByItem } from '../../../core/services/data-services/table-data.model';
import { TableDataService } from '../../../core/services/data-services/table-data.service'
import { ResourceType } from 'app/core/services/api-helper/resource-type';

export class DocumentTypeListTableDataService extends TableDataService {
    constructor(
        httpHelper: HttpHelperService,
        apiHelper: ApiHelperServiceNew,
        excelService: ExcelService,
        identifierSuffix: string = '',
        overrideFilterDefaults?: ITableFilterDefault[],
        overrideSortByItems?: SortByItem[]
    ) {
        const identifier: string = 'document-type-list';

        const tableFilters: TableFilter[] = [
            new TableFilter('Name', 'Name', 'Name', ''),
            new TableFilter('ParentGroupName', 'DefaultComplianceCategory/ComplianceGroup/ParentGroup/Name', 'Parent Group', []),
            new TableFilter('GroupName', 'DefaultComplianceCategory/ComplianceGroup/Name', 'Group', []),
            new TableFilter('CategoryName', 'DefaultComplianceCategory/Name', 'Category', []),
            new TableFilter('Expires', 'Expires', 'Expires', []),
            new TableFilter('ExpiryDays', 'ExpiryInformation/ExpiryDays', 'Expiry Days', ''),
            new TableFilter('ReminderDays', 'ExpiryInformation/ReminderDays', 'Reminder Days', ''),
            new TableFilter('OriginalSeenRequired', 'OriginalSeenRequired', 'O/S Required', []),
            new TableFilter('VisibleTo', 'VisibleToAndNextActionBy/VisibleTo', 'Visible To', []),
            new TableFilter('DefaultNextActionBy', 'VisibleToAndNextActionBy/DefaultNextActionBy', 'Default NAB', [])

        ];

        const filterOptions: FilterOption[] = [
            new FilterOption('ParentGroupName', true),
            new FilterOption('GroupName', true),
            new FilterOption('CategoryName', true),
            new FilterOption('Expires', true),
            new FilterOption('OriginalSeenRequired', true),
            new FilterOption('VisibleTo', true),
            new FilterOption('DefaultNextActionBy', true)
        ];

        const defaultSortBy: SortByItem[] = [
            { sortBy: 'Name', sortByDirection: SortByDirection.asc }
        ];

        let queryStringSelectExpand = '$expand=DefaultComplianceCategory($expand=ComplianceGroup($expand=ParentGroup($expand=ParentGroup)))';

        super(
            httpHelper,
            apiHelper,
            excelService,
            identifierSuffix.length > 0 ? identifier + '-' + identifierSuffix : identifier,
            ResourceType.DocumentType,
            tableFilters,
            filterOptions,
            defaultSortBy,
            queryStringSelectExpand);

        this.overrideDefaultTableFilters(overrideFilterDefaults);
        this.overrideDefaultSortByItems(overrideSortByItems);
    }
}
